import packegeJson from "../../../package.json";
// import { UserNotification } from "../../interfaces";

/** seting action types */
// export const actionTypes = {
//   SAVE_MAINTENANCE: "SAVE_MAINTENANCE",
//   SAVE_VERSION: "SAVE_VERSION",
//   SAVE_NOTIFICATIONS: "SAVE_NOTIFICATIONS",
//   SAVE_NOTIFICATIONS_UNREAD_COUNT: "SAVE_NOTIFICATIONS_UNREAD_COUNT"
// };

/*
 * Action creators for login
 */

// export const saveMaintenanceMode = (data: {mode: MaintenanceMode, scheduledDate?: Date}) => (dispatch) => {
//   dispatch({
//     type: actionTypes.SAVE_MAINTENANCE,
//     data: data
//   })
// }

export const getPackageJsonVersion = () => packegeJson?.version;

// export const updateVersion = (data: string) => (dispatch) => {
//   const isVersionChanged = !equalsIgnoreCase(data, packegeJson?.version);
//   dispatch({
//     type: actionTypes.SAVE_VERSION,
//     data: isVersionChanged
//   })
// }

// export const saveNotifications = (data: UserNotification[]) => (dispatch) => {
//   dispatch({
//     type: actionTypes.SAVE_NOTIFICATIONS,
//     data: data
//   })
// }

// export const saveSocketNotification = (data: UserNotification) => (dispatch, getState) => {
//   const notifications = getState().system.notifications;
//   const count = getState().system.notificationsUnreadCount;
//   dispatch({
//     type: actionTypes.SAVE_NOTIFICATIONS,
//     data: [data, ...notifications]
//   })
//   dispatch({
//     type: actionTypes.SAVE_NOTIFICATIONS_UNREAD_COUNT,
//     data: count + 1
//   })
// }

// export const saveNotificationsCount = (data: number) => (dispatch) => {
//   dispatch({
//     type: actionTypes.SAVE_NOTIFICATIONS_UNREAD_COUNT,
//     data: data
//   })
// }